<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'quotationModelDialog',
})
</script>
<template>
  <ant-modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-quotation-dialog'" :title="state.dialog.title" :width="state.dialog.width"
    :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt"
    :cancel-button-props="state.viewType === 'detail' ? { style: { display: 'none' } } : {}" @ok="onSubmit"
    @cancel="closeDialog" :closable="!hasCancelOrCloseButton" :maskClosable="!hasCancelOrCloseButton">
    <div class="form-content">
      <div class="setting-section-title">
        <span>城市设置</span>
      </div>
      <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" :wrapper-col="{ style: 'flex: 1' }">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="模型名称" name="modelName">
              <a-input v-model:value="state.ruleForm.modelName" placeholder="请输入模型名称" :maxlength="50"
                :show-count="state.viewType !== 'detail'" :disabled="state.viewType === 'detail'" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="省/市" name="areaIds">
              <div class="select-arrow-wrapper">
                <a-cascader :key="cascaderKey" v-model:value="cascaderValue" :options="cascaderOptions"
                  :field-names="{ value: 'id', label: 'label', children: 'children' }"
                  :disabled="state.viewType === 'detail'" multiple :max-tag-count="3" placeholder="请选择省/市" allow-clear
                  :getPopupContainer="(trigger) => trigger.parentNode" @change="handleCascaderChange"
                  @dropdownVisibleChange="onPopupVisibleChange" />
                <span class="select-arrow-icon">
                  <DownOutlined />
                </span>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="单价" name="unitPrice">
              <a-input v-model:value="unitPriceText" placeholder="请输入单价" :disabled="state.viewType === 'detail'"
                :maxlength="10" allow-clear @input="handleUnitPriceInput" @compositionend="handleUnitPriceInput" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="城市系数" name="coefficient">
              <a-input v-model:value="coefficientText" placeholder="请输入城市系数" :disabled="state.viewType === 'detail'"
                :maxlength="10" allow-clear @input="handleCoefficientInput" @compositionend="handleCoefficientInput" />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="setting-section">
          <div class="setting-section-title">
            <span>面积设置</span>
            <a-switch v-model:checked="state.ruleForm.sizeEnabled" checkedValue="1" unCheckedValue="0"
              :disabled="state.viewType === 'detail'" />
          </div>
          <template v-if="state.ruleForm.sizeEnabled === '1'">
            <div v-if="areaListError" class="setting-list-error">{{ areaListError }}</div>
            <a-row v-for="(item, index) in state.ruleForm.sizeSettings" :key="index" :gutter="14" class="setting-row">
              <a-col :span="12">
                <a-form-item label="面积" required :validate-status="areaErrors[index]?.sizeDictCode ? 'error' : ''"
                  :help="areaErrors[index]?.sizeDictCode">
                  <a-select v-model:value="item.sizeDictCode" :options="getSizeOptions(index)" placeholder="请选择面积"
                    :fieldNames="{ label: 'name', value: 'code' }" :disabled="state.viewType === 'detail'"
                    @change="validateArea(item, index)" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item label="面积系数" required :validate-status="areaErrors[index]?.coefficient ? 'error' : ''"
                  :help="areaErrors[index]?.coefficient">
                  <a-input v-model:value="item.coefficient" placeholder="请输入面积系数"
                    :disabled="state.viewType === 'detail'" :maxlength="10" allow-clear
                    @input="(e) => handleAreaInput(e, item, index)"
                    @compositionend="(e) => handleAreaInput(e, item, index)"
                    @blur="validateAreaCoefficient(item, index)" />
                </a-form-item>
              </a-col>
              <a-button v-if="state.ruleForm.sizeSettings.length > 1" class="setting-delete" type="text"
                :disabled="state.viewType === 'detail'" @click="removeAreaConfig(index)">
                <CloseCircleFilled />
              </a-button>
            </a-row>
            <a-button v-if="state.ruleForm.sizeSettings.length < stateT.sizeDictCodeList.length"
              class="add-setting-button" type="link" :disabled="state.viewType === 'detail'" @click="addAreaConfig"> +
              新增面积 </a-button>
          </template>
        </div>
        <div class="setting-section">
          <div class="setting-section-title">
            <span>行业设置</span>
            <a-switch v-model:checked="state.ruleForm.industryEnabled" checkedValue="1" unCheckedValue="0"
              :disabled="state.viewType === 'detail'" />
          </div>
          <template v-if="state.ruleForm.industryEnabled === '1'">
            <div v-if="industryListError" class="setting-list-error">{{ industryListError }}</div>
            <a-row v-for="(item, index) in state.ruleForm.industrySettings" :key="index" :gutter="16"
              class="setting-row">
              <a-col :span="12">
                <a-form-item label="行业" required :validate-status="industryErrors[index]?.industryIds ? 'error' : ''"
                  :help="industryErrors[index]?.industryIds">
                  <a-cascader :value="getIndustryCascaderValue(item.industryIds)" style="width: 100%" multiple
                    max-tag-count="responsive" :options="getIndustryOptions(index)"
                    :show-checked-strategy="Cascader.SHOW_CHILD"
                    :fieldNames="{ label: 'typeName', value: 'id', children: 'children' }" placeholder="请选择行业"
                    :disabled="state.viewType === 'detail'" show-search allow-clear
                    @change="(value) => handleIndustryChange(value, item, index)"></a-cascader>
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item label="行业系数" required :validate-status="industryErrors[index]?.coefficient ? 'error' : ''"
                  :help="industryErrors[index]?.coefficient">
                  <a-input v-model:value="item.coefficient" placeholder="请输入行业系数"
                    :disabled="state.viewType === 'detail'" :maxlength="10" allow-clear
                    @input="(e) => handleIndustryInput(e, item, index)"
                    @compositionend="(e) => handleIndustryInput(e, item, index)"
                    @blur="validateIndustryCoefficient(item, index)" />
                </a-form-item>
              </a-col>
              <a-button v-if="state.ruleForm.industrySettings.length > 1" class="setting-delete" type="text"
                :disabled="state.viewType === 'detail'" @click="removeIndustryConfig(index)">
                <CloseCircleFilled />
              </a-button>
            </a-row>
            <a-button class="add-setting-button" type="link" :disabled="state.viewType === 'detail'"
              @click="addIndustryConfig"> + 新增行业 </a-button>
          </template>
        </div>
        <!-- 优先级、替换冲突字段隐藏 -->
        <!-- <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="优先级" name="priority">
              <a-input
                v-model:value="state.ruleForm.priority"
                placeholder="请输入优先级"
                :disabled="state.viewType === 'detail'"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="替换冲突" name="replaceConflict">
              <a-switch
                v-model:checked="state.ruleForm.replaceConflict"
                :disabled="state.viewType === 'detail'"
              />
            </a-form-item>
          </a-col>
        </a-row> -->
      </a-form>
    </div>
  </ant-modal>
</template>
<script setup lang="ts" name="quotationModelDialog">
import { reactive, ref, computed, h, inject } from 'vue'
import { CloseCircleFilled, DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Cascader, Modal } from 'ant-design-vue'
import { cloneDeep } from 'lodash-es'
import { useQuotation } from '@/store/quotation/quotation'
const stateT: any = inject('stateT')
const quotationStore = useQuotation()

const props = defineProps<{
  areaTreeData: any[]
}>()

const emit = defineEmits(['createUpdate'])
const formRef = ref()

const INIT_RULE_FORM = {
  id: undefined as number | undefined,
  modelName: '',
  areaIds: [] as string[],
  unitPrice: undefined as number | undefined,
  coefficient: undefined as number | undefined,
  priority: undefined as number | undefined,
  replaceConflict: false,
  sizeEnabled: '1' as string | undefined,
  sizeSettings: [{ sizeDictCode: undefined as string | undefined, coefficient: '' }] as any[],
  industryEnabled: '1' as string | undefined,
  industrySettings: [{ industryIds: [] as string[], coefficient: '' }] as any[]
}

const state = reactive({
  dialog: {
    visible: false,
    title: '',
    submitTxt: '',
    width: '969px'
  },
  loading: {
    submit: false
  },
  ruleForm: cloneDeep(INIT_RULE_FORM),
  rules: {
    modelName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
    areaIds: [{ required: true, type: 'array', message: '请选择省/市', trigger: 'change' }],
    unitPrice: [{ required: true, message: '请输入单价', trigger: 'blur' }],
    coefficient: [{ required: true, message: '请输入系数', trigger: 'blur' }]
  },
  viewType: ''
})

const hasCancelOrCloseButton = computed(() => state.viewType !== 'detail' || state.dialog.submitTxt === '关闭')

const cascaderValue = ref<string[][]>([])
const cascaderKey = ref(0)
const unitPriceText = ref('')
const coefficientText = ref('')
const areaErrors = ref<Record<number, { sizeDictCode?: string; coefficient?: string }>>({})
const industryErrors = ref<Record<number, { industryIds?: string; coefficient?: string }>>({})
const areaListError = ref('')
const industryListError = ref('')

const createAreaConfig = () => ({ sizeDictCode: undefined as string | undefined, coefficient: '' })
const createIndustryConfig = () => ({ key: Date.now() + Math.random(), industryIds: [] as string[], coefficient: '' })

const addAreaConfig = () => {
  state.ruleForm.sizeSettings.push(createAreaConfig())
}

const removeAreaConfig = (index: number) => {
  if (state.ruleForm.sizeSettings.length > 1) {
    state.ruleForm.sizeSettings.splice(index, 1)
    areaErrors.value = {}
  }
}

const addIndustryConfig = () => {
  state.ruleForm.industrySettings.push(createIndustryConfig())
}

const removeIndustryConfig = (index: number) => {
  if (state.ruleForm.industrySettings.length > 1) {
    state.ruleForm.industrySettings.splice(index, 1)
    industryErrors.value = {}
  }
}

const getSizeOptions = (currentIndex: number) => {
  const selectedByOtherRows = new Set(
    state.ruleForm.sizeSettings
      .filter((_, index) => index !== currentIndex)
      .map((item) => item.sizeDictCode)
      .filter((value) => value !== undefined && value !== null)
      .map(String)
  )

  return (stateT.sizeDictCodeList || []).map((option: any) => ({
    ...option,
    disabled: option.disabled || selectedByOtherRows.has(String(option.code))
  }))
}

const getSelectedIndustryIds = (industryIds: any[] = []) => {
  return (industryIds || [])
    .map((value) => Array.isArray(value) ? value[value.length - 1] : value)
    .filter((value) => value !== undefined && value !== null)
    .map(String)
}

const getIndustryCascaderValue = (industryIds: any[] = []) => {
  const selectedIds = new Set(getSelectedIndustryIds(industryIds))

  return (stateT.venueTypeData || []).flatMap((parent: any) =>
    (parent.children || [])
      .filter((child: any) => selectedIds.has(String(child.id)))
      .map((child: any) => [parent.id, child.id])
  )
}

const getIndustryOptions = (currentIndex: number) => {
  const selectedByOtherRows = new Set(
    state.ruleForm.industrySettings.flatMap((item, index) =>
      index === currentIndex ? [] : getSelectedIndustryIds(item.industryIds)
    )
  )

  return (stateT.venueTypeData || []).map((parent: any) => ({
    ...parent,
    children: (parent.children || []).map((child: any) => ({
      ...child,
      disabled: child.disabled || selectedByOtherRows.has(String(child.id))
    }))
  }))
}

const handleIndustryChange = (value: any[], item: any, index: number) => {
  item.industryIds = getSelectedIndustryIds(value)
  if (industryErrors.value[index]) delete industryErrors.value[index].industryIds
}

const clearAreaError = (index: number, field: 'area' | 'coefficient') => {
  if (areaErrors.value[index]) delete areaErrors.value[index][field]
}

const validateArea = (item: any, index: number) => {
  const errors = { ...areaErrors.value[index] }
  if (!item.sizeDictCode) errors.sizeDictCode = '请选择面积'
  else delete errors.sizeDictCode

  if (Object.keys(errors).length) areaErrors.value[index] = errors
  else delete areaErrors.value[index]
}
const handleIndustryInput = (e: any, item: any, index: number) => {
  const target = e.target as HTMLInputElement
  let val = target.value
  val = val
    .replace(/[^\d.]/g, '')
    .replace(/(\..*?)\..*/g, '$1')
    .slice(0, 10)
  target.value = val
  item.coefficient = val ? parseFloat(val) : undefined
  clearIndustryError(index, 'coefficient')
}

const handleAreaInput = (e: any, item: any, index: number) => {
  const target = e.target as HTMLInputElement
  let val = target.value
  val = val
    .replace(/[^\d.]/g, '')
    .replace(/(\..*?)\..*/g, '$1')
    .slice(0, 10)
  target.value = val
  item.coefficient = val ? parseFloat(val) : undefined
  clearAreaError(index, 'coefficient')
}

const clearIndustryError = (index: number, field: 'industryIds' | 'coefficient') => {
  if (industryErrors.value[index]) delete industryErrors.value[index][field]
}

const validateIndustry = (item: any) => {
  const errors = { ...industryErrors.value[item.key] }
  if (!item.industryIds.length) errors.industryIds = '请选择行业'
  else delete errors.industryIds

  if (Object.keys(errors).length) industryErrors.value[item.key] = errors
  else delete industryErrors.value[item.key]
}

const isEmptyCoefficient = (value: unknown) => value === undefined || value === null || value === '' || Number.isNaN(value)

const validateAreaCoefficient = (item: any, index: number) => {
  if (isEmptyCoefficient(item.coefficient)) {
    areaErrors.value[index] = { ...areaErrors.value[index], coefficient: '请输入面积系数' }
  }
}

const validateIndustryCoefficient = (item: any, index: number) => {
  if (isEmptyCoefficient(item.coefficient)) {
    industryErrors.value[index] = { ...industryErrors.value[index], coefficient: '请输入行业系数' }
  }
}

const validateExtraSettings = () => {
  let valid = true
  areaErrors.value = {}
  industryErrors.value = {}
  areaListError.value = ''
  industryListError.value = ''

  if (state.ruleForm.sizeEnabled === '1') {
    if (!state.ruleForm.sizeSettings.length) {
      areaListError.value = '请至少新增一组面积设置'
      valid = false
    }
    const sizeCodeCounts = state.ruleForm.sizeSettings
      .map((item) => item.sizeDictCode)
      .filter((value) => value !== undefined && value !== null)
      .map(String)
      .reduce((counts, code) => counts.set(code, (counts.get(code) || 0) + 1), new Map<string, number>())

    state.ruleForm.sizeSettings.forEach((item, index) => {
      const errors: { sizeDictCode?: string; coefficient?: string } = {}
      if (!item.sizeDictCode) errors.sizeDictCode = '请选择面积'
      else if (sizeCodeCounts.get(String(item.sizeDictCode))! > 1) errors.sizeDictCode = '面积不能重复选择'
      if (isEmptyCoefficient(item.coefficient)) errors.coefficient = '请输入面积系数'
      if (Object.keys(errors).length) {
        areaErrors.value[index] = errors
        valid = false
      }
    })
  }

  if (state.ruleForm.industryEnabled === '1') {
    if (!state.ruleForm.industrySettings.length) {
      industryListError.value = '请至少新增一组行业设置'
      valid = false
    }
    const industryIdCounts = state.ruleForm.industrySettings
      .flatMap((item) => getSelectedIndustryIds(item.industryIds))
      .reduce((counts, id) => counts.set(id, (counts.get(id) || 0) + 1), new Map<string, number>())

    state.ruleForm.industrySettings.forEach((item, index) => {
      const errors: { industryIds?: string; coefficient?: string } = {}
      if (!item.industryIds.length) errors.industryIds = '请选择行业'
      else if (getSelectedIndustryIds(item.industryIds).some((id) => industryIdCounts.get(id)! > 1)) {
        errors.industryIds = '行业不能重复选择'
      }
      if (isEmptyCoefficient(item.coefficient)) errors.coefficient = '请输入行业系数'
      if (Object.keys(errors).length) {
        industryErrors.value[index] = errors
        valid = false
      }
    })
  }

  return valid
}

const cascaderOptions = computed(() => {
  return (props.areaTreeData || [])
    .filter((item: any) => item.level === '1')
    .map((item: any) => ({
      ...item,
      children: (item.children || []).filter((c: any) => c.level === '2').map((c: any) => ({ ...c, children: [] }))
    }))
})

const findCascaderPaths = (tree: any[], ids: (number | string)[]): string[][] => {
  const paths: string[][] = []
  const idSet = new Set(ids.map((id) => String(id)))
  const walk = (nodes: any[], path: string[]) => {
    if (!nodes) return
    for (const node of nodes) {
      const cur = [...path, String(node.id)]
      if (idSet.has(String(node.id))) paths.push(cur)
      walk(node.children, cur)
    }
  }
  walk(tree, [])
  console.log('paths: ', paths)
  return paths
}

const recoverAreaIds = (rawAreaIds: string[], treeData: any[]): string[] => {
  const result: string[] = []
  const rawSet = new Set(rawAreaIds)
  const walk = (nodes: any[]) => {
    if (!nodes) return
    for (const node of nodes) {
      if (rawSet.has(String(node.id))) {
        result.push(String(node.id))
      }
      walk(node.children)
    }
  }
  walk(treeData)
  return result
}

const handleCascaderChange = (value: string[][]) => {
  cascaderValue.value = value || []
  state.ruleForm.areaIds = (value || []).map((path) => String(path[path.length - 1]))
}

const onPopupVisibleChange = (visible: boolean) => {
  if (!visible || !cascaderValue.value.length) return

  let attempts = 0
  const maxAttempts = 5
  const tryScroll = () => {
    const menus = document.querySelectorAll('.ant-cascader-menu')
    if (!menus.length) {
      if (++attempts < maxAttempts) setTimeout(tryScroll, 100)
      return
    }

    let found = false
    menus.forEach((menu) => {
      const items = menu.querySelectorAll<HTMLElement>('.ant-cascader-menu-item')
      for (const item of Array.from(items)) {
        if (item.querySelector('.ant-checkbox-checked') || item.querySelector('.ant-cascader-checkbox-checked')) {
          item.scrollIntoView({ block: 'center' })
          found = true
          break
        }
      }
    })

    if (!found && ++attempts < maxAttempts) {
      setTimeout(tryScroll, 100)
    }
  }

  setTimeout(tryScroll, 200)
}

const normalizeEnabled = (value: unknown) => value === '1' || value === 1 || value === true ? '1' : '0'

const openDialog = (type: string, row?: any) => {
  const treeData = cascaderOptions.value

  state.viewType = type

  if (type === 'edit' && row) {
    state.dialog.title = '修改模型'
    state.dialog.submitTxt = '修改'
  } else if (type === 'detail' && row) {
    state.dialog.title = '报价模型'
    state.dialog.submitTxt = '关闭'
  } else {
    state.dialog.title = '新增模型'
    state.dialog.submitTxt = '确认'
  }

  if ((type === 'edit' || type === 'detail') && row) {
    const recoveredAreaIds = recoverAreaIds(row.areaIds || [], treeData)
    state.ruleForm = {
      id: row.id,
      modelName: row.modelName || '',
      areaIds: recoveredAreaIds,
      unitPrice: row.unitPrice,
      coefficient: row.coefficient,
      priority: row.priority,
      replaceConflict: row.replaceConflict || false,
      sizeEnabled: normalizeEnabled(row.sizeEnabled),
      sizeSettings: row.sizeSettings?.length ? cloneDeep(row.sizeSettings) : [createAreaConfig()],
      industryEnabled: normalizeEnabled(row.industryEnabled),
      industrySettings: row.industrySettings?.length
        ? row.industrySettings.map((item: any) => ({
          ...cloneDeep(item),
          industryIds: getSelectedIndustryIds(item.industryIds)
        }))
        : [createIndustryConfig()]
    }
    unitPriceText.value = row.unitPrice !== undefined && row.unitPrice !== null ? String(row.unitPrice) : ''
    coefficientText.value = row.coefficient !== undefined && row.coefficient !== null ? String(row.coefficient) : ''
    cascaderValue.value = findCascaderPaths(treeData, recoveredAreaIds)
  } else {
    state.ruleForm = cloneDeep(INIT_RULE_FORM)
    unitPriceText.value = ''
    coefficientText.value = ''
    cascaderValue.value = []
  }
  formRef.value?.clearValidate()

  cascaderKey.value++
  state.dialog.visible = true
}

const closeDialog = () => {
  state.dialog.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(INIT_RULE_FORM)
  cascaderValue.value = []
  unitPriceText.value = ''
  coefficientText.value = ''
  formRef.value?.resetFields()
}

const handleUnitPriceInput = (e: Event) => {
  const target = e.target as HTMLInputElement
  let val = target.value
  val = val
    .replace(/[^\d.]/g, '')
    .replace(/(\..*?)\..*/g, '$1')
    .slice(0, 10)
  target.value = val
  unitPriceText.value = val
  state.ruleForm.unitPrice = val ? parseFloat(val) : undefined
}

const handleCoefficientInput = (e: Event) => {
  const target = e.target as HTMLInputElement
  let val = target.value
  val = val
    .replace(/[^\d.]/g, '')
    .replace(/(\..*?)\..*/g, '$1')
    .slice(0, 10)
  target.value = val
  coefficientText.value = val
  state.ruleForm.coefficient = val ? parseFloat(val) : undefined
}

const doSubmit = async () => {
  const sizeEnabled = state.ruleForm.sizeEnabled === '1'
  const industryEnabled = state.ruleForm.industryEnabled === '1'
  const param = {
    ...cloneDeep(state.ruleForm),
    sizeSettings: sizeEnabled ? state.ruleForm.sizeSettings : [],
    sizeEnabled: sizeEnabled ? '1' : '0',
    industryEnabled: industryEnabled ? '1' : '0',
    industrySettings: industryEnabled
      ? state.ruleForm.industrySettings.map((item) => ({
        ...item,
        industryIds: getSelectedIndustryIds(item.industryIds)
      }))
      : [],
  }
  try {
    if (state.viewType === 'add') {
      await quotationStore.createQuotationModel(param)
    } else {
      await quotationStore.updateQuotationModel(param)
    }
    state.loading.submit = false
    emit('createUpdate')
  } catch {
    state.loading.submit = false
  }
}

const onSubmit = () => {
  if (state.viewType === 'detail') {
    closeDialog()
    return
  }
  const extraSettingsValid = validateExtraSettings()
  formRef.value
    .validate()
    .then(async () => {
      if (!extraSettingsValid) return
      state.loading.submit = true
      try {
        const conflictParam = {
          id: String(state.ruleForm.id || ''),
          areaIds: state.ruleForm.areaIds || []
        }
        const conflictList: any = await quotationStore.checkAreaConflict(conflictParam)
        const conflicts = conflictList || []
        if (conflicts.length === 0) {
          await doSubmit()
        } else {
          const areaNames = conflicts
            .map((item: any) => item.areaName)
            .filter(Boolean)
            .join('、')
          state.loading.submit = false
          Modal.confirm({
            transitionName: '',
            title: '提示',
            icon: () => h(ExclamationCircleOutlined),
            centered: true,
            content: `【${areaNames}】已存在报价模型，是否将当前城市从原有模型中删除？`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              return doSubmit()
            }
          })
        }
      } catch {
        state.loading.submit = false
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 20px 35px 32px 35px;
}

.setting-section {
  margin-bottom: 12px;
}

.setting-section-title {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 40px;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
}

.setting-list-error {
  margin: -4px 0 8px 42px;
  color: #ff4d4f;
  font-size: 14px;
}

.setting-row {
  position: relative;
}

.setting-row :deep(.ant-form-item-control) {
  position: relative;
}

.setting-row :deep(.ant-form-item-explain-connected) {
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 1;
  width: 100%;
}

.setting-row :deep(.ant-form-item-margin-offset) {
  display: none;
}

.setting-delete {
  margin-left: 14px;
  padding: 0;
  color: #d9d9d9;
  font-size: 18px;
}

.add-setting-button {
  padding-left: 42px;
  color: #666;
}

:global(.wrap-quotation-dialog .ant-modal-footer) {
  padding-top: 18px;
}

:global(.wrap-quotation-dialog .ant-modal-body) {
  max-height: calc(100vh - 400px);
  overflow-y: auto;
}

// ===== 表单 =====
:deep(.ant-form-item) {
  margin-bottom: 24px;
  padding-bottom: 0;
}

:deep(.ant-form-item-label) {
  margin-left: 0px;
  margin-right: 5px;
  width: 80px;
  text-align: right;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  height: 40px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

:deep(.ant-input-number) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-input-number-input) {
  height: 100%;
}

.space-divider {
  height: 1px;
  background: #A0B8E5;
}

.select-arrow-wrapper {
  position: relative;
}

.select-arrow-icon {
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  pointer-events: none;
  z-index: 1;
}
</style>
